<ng-container *transloco="let t;">
<div class="container sign-bankId-container">
    <div class="row">
        <div class="col-lg-12 col-12">
            <div class="bankId-box-header">
                <h2> {{ t("Bankid box label for Swedish bankid (Signing page - section) - Sign document with Swedish BankID", {document: roleDetail?.roleable?.visible_name ?? roleDetail?.roleable?.name}) }}</h2>
            </div>
            <ng-container *ngIf="(isMobile); else desktop">
               <ng-template [ngTemplateOutlet]="sameDevice"></ng-template>
            </ng-container>
            <ng-template #desktop>
                <ul ngbNav #navJustified="ngbNav" class="nav-tabs">
                    <li ngbNavItem="mobileBankId">
                        <a ngbNavLink>{{t("Mobile BankID tab text (Signing page - section) - Mobile BankID")}}</a>
                        <ng-template ngbNavContent>
                            <div class="bankId-box-tab-content">
                                <div class="bankId-tab-content-left">
                                    <h5 class="bankId-tab-title">
                                        <strong> {{roleDetail.recipient.firstname}} {{roleDetail.recipient?.lastname ?? ''}}, </strong>{{ t("Bankid box label for recipient (Signing page - section) - please complete your signature using BankID") }}
                                    </h5>

                                    <h5 class="bankId-tab-title" *ngIf="roleDetail.recipient.persnol_no">
                                        {{ t("Bankid social security text (Signing page - section) - Connected Social Security Number is") }}: <strong> {{roleDetail.recipient.persnol_no}} </strong>
                                    </h5>

                                    <button [disabled]="bankidProcess" type="button" class="btn btn-success signWithBankId-process-btn" (click)="generateQrcode()">
                                        {{t("Bankid button text (Signing page - section) - Sign with BankID")}}
                                        <img src="../../assets/images/icons/bankid-iconSigning.svg">
                                    </button>
                                </div>

                                <div class="bankId-tab-content-right">
                                    <h5> {{t("Bankid box text (Signing page - section) - How to log in with a mobile BankID")}} </h5>
                                    <p>{{t("Bankid box message (Signing page - section) - To log in, you need a mobile phone or tablet with BankID security app installed")}}.</p>
                                    <p class="text-primary cursor-pointer" (click)="openSamsungHelpModal()" *ngIf="isSamsungBrowser">{{t("Bankid samsung browser text (Signing page - section) - Samsung browser")}}?</p>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li ngbNavItem ngbNavItem="BankID">
                        <a ngbNavLink>{{t("BankID tab text (Signing page - section) - BankID")}}</a>
                        <ng-template ngbNavContent>
                            <ng-template [ngTemplateOutlet]="sameDevice"></ng-template>
                        </ng-template>
                    </li>
                </ul>
            <div [ngbNavOutlet]="navJustified" class=""></div>    
            </ng-template>
        </div>
    </div>
</div>

<!---->
<ng-template #sameDevice>
 <div class="bankId-box-tab-content">
    <div class="bankId-tab-content-left">
        <h5 class="bankId-tab-title">
            <strong> {{roleDetail.recipient.firstname}} {{roleDetail.recipient?.lastname ?? ''}}, </strong>{{ t("Bankid box label for recipient (Signing page - section) - please complete your signature using BankID") }}
        </h5>
        <h5 class="bankId-tab-title" *ngIf="roleDetail.recipient.persnol_no">

            {{ t("Bankid social security text (Signing page - section) - Connected Social Security Number is") }}: <strong> {{roleDetail.recipient.persnol_no}} </strong>
        </h5>
        <div class="input-group input-group-merge" *ngIf="!roleDetail.recipient.persnol_no">
            <div class="input-group-prepend">
                <span class="input-group-text" id="personalId">
                    <i class="bi bi-person-badge"></i>
                </span>
            </div>
            <input [(ngModel)]="typePersnolNo" type="text" class="form-control" [placeholder]='t("Bnakid field placeholder text (Signing page - section) - Personal ID")' aria-label="Personal ID" aria-describedby="personalId" [value]="typePersnolNo"/>
        </div>

        <button [disabled]="bankidProcess" type="button" class="btn btn-success signWithBankId-process-btn" (click)="openBankIdDeepLink()">
            {{t("Bankid button text (Signing page - section) - Sign with BankID")}}
            <img src="../../assets/images/icons/bankid-iconSigning.svg">
        </button>
    </div>

    <div class="bankId-tab-content-right">
        <p>{{ t("Bankid card reader message (Signing page - section) - To sign with a card, you need a card reader and a computer with the BankID security app installed") }}.</p>
    </div>
</div>
</ng-template>

</ng-container>